import theGameIndex_Thumbnail from '../../images/spring-summer-2025/index-thumbnails/keeping-his-head-in-the-game-index.jpg'
import disneyIndex_Thumbnail from '../../images/spring-summer-2025/index-thumbnails/the-talent-behind-disney-communications-index.jpg'
import executiveIndex_Thumbnail from '../../images/spring-summer-2025/index-thumbnails/a-business-executive-explains-the-titan-advantage-index.jpg'
import expertsIndex_Thumbnail from '../../images/spring-summer-2025/index-thumbnails/experts-make-the-case-for-college-index.jpg'
import choseCSUFIndex_Thumbnail from '../../images/spring-summer-2025/index-thumbnails/why-i-chose-cal-state-fullerton-index.jpg'
import presidents_IndexThumbnail from '../../images/fall-winter-2024/index-thumbnails/story6-index-thumbnails-1920x1080.jpg'

import presidents_Thumbnail from '../../images/fall-winter-2024/menu-thumbnails/story6-menu-thumbnails-400x400.jpg'
import presidents_SmallThumbnail from '../../images/fall-winter-2024/small-thumbnails/story6-small-thumbnails-100x100.jpg'
import presidents_SmallRectThumbnail from '../../images/fall-winter-2024/small-thumbnails-rect/story6-thumbnails-rect-250x125.jpg'

import theGameMenu_Thumbnail from '../../images/spring-summer-2025/menu-thumbnails/keeping-his-head-in-the-game-menu.jpg'
import disneyMenu_Thumbnail from '../../images/spring-summer-2025/menu-thumbnails/the-talent-behind-disney-communications-menu.jpg'
import executiveMenuThumbnail from '../../images/spring-summer-2025/menu-thumbnails/a-business-executive-explains-the-titan-advantage-menu.jpg'
import expertsMenu_Thumbnail from '../../images/spring-summer-2025/menu-thumbnails/experts-make-the-case-for-college-menu.jpg'
import choseCSUFMenu_Thumbnail from '../../images/spring-summer-2025/menu-thumbnails/why-i-chose-cal-state-fullerton-menu.jpg'

import ClassNotes_Thumbnail from '../../images/fall-winter-2023/class-notes.jpg'
import ClassNotes_IndexThumbnail from '../../images/fall-winter-2023/class-notes-banner.jpg'

export const springSummer2025Stories = [
    {
        slug: 'keeping-his-head-in-the-game',
        title: 'Keeping His Head in the Game',
        subtitle:
            'After a successful pitching career in Major League Baseball, Ricky Romero returned to Cal State Fullerton to earn a college degree.',
        storyType: 'feature',
        thumbnail: theGameMenu_Thumbnail,
        thumbnailSmall: theGameMenu_Thumbnail,
        thumbnailSmallRect: theGameMenu_Thumbnail,
        thumbnailIndex: theGameIndex_Thumbnail,
        homepageTextPosition: 'right',
    },
    {
        slug: 'the-talent-behind-disney-communications',
        title: 'The Talent Behind Disney Communications',
        subtitle: 'Cal State Fullerton alumni make up a third of the communications and public affairs team at Disneyland Resort.',
        storyType: 'feature',
        thumbnail: disneyMenu_Thumbnail,
        thumbnailSmall: disneyMenu_Thumbnail,
        thumbnailSmallRect: disneyMenu_Thumbnail,
        thumbnailIndex: disneyIndex_Thumbnail,
        homepageTextPosition: 'right',
    },
    {
        slug: 'a-business-executive-explains-the-titan-advantage',
        title: 'A Business Executive Explains the Titan Advantage',
        subtitle:
            'Two-time business alum Tim Goff helped build a nearly $2 billion business with his Cal State Fullerton degrees. He reflects on the edge that Titans have in the workforce.',
        storyType: 'feature',
        thumbnail: executiveMenuThumbnail,
        thumbnailSmall: executiveMenuThumbnail,
        thumbnailSmallRect: executiveMenuThumbnail,
        thumbnailIndex: executiveIndex_Thumbnail,
        homepageTextPosition: 'right',
    },
    {
        slug: 'experts-make-the-case-for-college',
        title: 'Experts Make the Case for College',
        subtitle: 'A Cal State Fullerton economist, psychologist and sociologist explain why a college degree matters.',
        storyType: 'feature',
        thumbnail: expertsMenu_Thumbnail,
        thumbnailSmall: expertsMenu_Thumbnail,
        thumbnailSmallRect: expertsMenu_Thumbnail,
        thumbnailIndex: expertsIndex_Thumbnail,
        homepageTextPosition: 'right',
    },
    {
        slug: 'why-i-chose-cal-state-fullerton',
        title: 'Why I Chose Cal State Fullerton',
        subtitle: 'Three Titans reflect on their motivations, doubts and lessons learned while pursuing a college degree.',
        storyType: 'feature',
        thumbnail: choseCSUFMenu_Thumbnail,
        thumbnailSmall: choseCSUFMenu_Thumbnail,
        thumbnailSmallRect: choseCSUFMenu_Thumbnail,
        thumbnailIndex: choseCSUFIndex_Thumbnail,
        homepageTextPosition: 'left',
    },
    {
        slug: 'class-notes',
        title: 'Alumni Class Notes',
        subtitle:
            'Class Notes is the place to catch up. Let fellow alumni know about career moves, awards and honors, publications and performances, births and marriages, and other life events.',
        storyType: 'feature',
        thumbnail: ClassNotes_Thumbnail,
        thumbnailSmall: ClassNotes_Thumbnail,
        thumbnailSmallRect: ClassNotes_IndexThumbnail,
        thumbnailIndex: ClassNotes_IndexThumbnail,
        homepageTextPosition: 'left',
        external: 'TRUE',
        url: 'https://alumni.fullerton.edu/class-notes/',
        buttonText: 'Read Class Notes',
    },
    {
        slug: 'presidents-message',
        title: 'President’s Message',
        subtitle: 'Caption Needed',
        storyType: 'feature',
        thumbnail: presidents_Thumbnail,
        thumbnailSmall: presidents_SmallThumbnail,
        thumbnailSmallRect: presidents_SmallRectThumbnail,
        thumbnailIndex: presidents_IndexThumbnail,
        homepageTextPosition: 'left',
    },
]
